// HELPERS
import tableFilter from '../../../../helpers/tableFilter';

// UTILS
import naUTL from '../../../../../../utils/naUTL';

const jsonTableRow = (dataSources) => {
  const { phone, residential, watchlistAML } = dataSources;

  const table = [
    {
      col1: 'Status',
      col2: naUTL(residential.status),
      col3: naUTL(watchlistAML.status),
      col4: naUTL(phone.status),
    },
    {
      col1: 'Safe Harbour Score',
      col2: naUTL(residential.safeHarbourScore),
      col3: naUTL(watchlistAML.safeHarbourScore),
      col4: naUTL(phone.safeHarbourScore),
    },
    {
      col1: 'Identity Verified',
      col2: naUTL(residential.identityVerified),
      col3: naUTL(watchlistAML.identityVerified),
      col4: naUTL(phone.identityVerified),
    },
    {
      col1: 'Social Security Number Verified',
      col2: naUTL(residential.verifications.socialSecurityNo),
      col3: naUTL(watchlistAML.verifications.socialSecurityNo),
      col4: naUTL(phone.verifications.socialSecurityNo),
    },
    {
      col1: 'First Name Verified',
      col2: naUTL(residential.verifications.firstName),
      col3: naUTL(watchlistAML.verifications.firstName),
      col4: naUTL(phone.verifications.firstName),
    },
    {
      col1: 'Middle Name Verified',
      col2: naUTL(residential.verifications.middleName),
      col3: naUTL(watchlistAML.verifications.middleName),
      col4: naUTL(phone.verifications.middleName),
    },
    {
      col1: 'Last Name Verified',
      col2: naUTL(residential.verifications.lastName),
      col3: naUTL(watchlistAML.verifications.lastName),
      col4: naUTL(phone.verifications.lastName),
    },
    {
      col1: 'Date Of Birth Verified',
      col2: naUTL(residential.verifications.dateOfBirth),
      col3: naUTL(watchlistAML.verifications.dateOfBirth),
      col4: naUTL(phone.verifications.dateOfBirth),
    },
    {
      col1: 'Gender Verified',
      col2: naUTL(residential.verifications.gender),
      col3: naUTL(watchlistAML.verifications.gender),
      col4: naUTL(phone.verifications.gender),
    },
    {
      col1: 'Name Match Score',
      col2: naUTL(residential.nameMatchScore),
      col3: naUTL(watchlistAML.nameMatchScore),
      col4: naUTL(phone.nameMatchScore),
    },
    {
      col1: 'Phone Number Verified',
      col2: naUTL(residential.verifications.phoneNo),
      col3: naUTL(watchlistAML.verifications.phoneNo),
      col4: naUTL(phone.verifications.phoneNo),
    },
    {
      col1: 'Email Address Verified',
      col2: naUTL(residential.verifications.email),
      col3: naUTL(watchlistAML.verifications.email),
      col4: naUTL(phone.verifications.email),
    },
    {
      col1: 'Street Verified',
      col2: naUTL(residential.verifications.addressElement1),
      col3: naUTL(watchlistAML.verifications.addressElement1),
      col4: naUTL(phone.verifications.addressElement1),
    },
    {
      col1: 'Suburb Verified',
      col2: naUTL(residential.verifications.addressElement3),
      col3: naUTL(watchlistAML.verifications.addressElement3),
      col4: naUTL(phone.verifications.addressElement3),
    },
    {
      col1: 'State Verified',
      col2: naUTL(residential.verifications.addressElement4),
      col3: naUTL(watchlistAML.verifications.addressElement4),
      col4: naUTL(phone.verifications.addressElement4),
    },
    {
      col1: 'Post Code Verified',
      col2: naUTL(residential.verifications.addressElement5),
      col3: naUTL(watchlistAML.verifications.addressElement5),
      col4: naUTL(phone.verifications.addressElement5),
    },
    {
      col1: 'Address Match Score',
      col2: naUTL(residential.addressMatchScore),
      col3: naUTL(watchlistAML.addressMatchScore),
      col4: naUTL(phone.addressMatchScore),
    },
  ];

  return tableFilter(table);
};

export default jsonTableRow;
